import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { dramatstraAPI } from '../services/api';
import toast from 'react-hot-toast';

export function useWatchHistory(params?: { page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['watch-history', params?.page, params?.limit],
    queryFn: async () => {
      const response = await dramatstraAPI.watchHistory.list(params);
      return response.data;
    },
    staleTime: 2 * 60 * 1000,
  });
}

export function useContinueWatching(limit: number = 10) {
  return useQuery({
    queryKey: ['watch-history', 'continue', limit],
    queryFn: async () => {
      const response = await dramatstraAPI.watchHistory.list({
        limit,
      });
      return response.data?.data || [];
    },
    staleTime: 2 * 60 * 1000,
  });
}

export function useSaveWatchProgress() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: {
      episodeId: string;
      watchedSeconds: number;
      durationSeconds: number;
    }) => {
      const response = await dramatstraAPI.watchHistory.save(data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['watch-history'] });
    },
    onError: (error: any) => {
      console.error('Erro ao salvar progresso:', error);
    },
  });
}

export function useEpisodeProgress(episodeId: string | null) {
  return useQuery({
    queryKey: ['episode-progress', episodeId],
    queryFn: async () => {
      if (!episodeId) return null;
      const response = await dramatstraAPI.watchHistory.getProgress(episodeId);
      return (response.data as any)?.data || null;
    },
    enabled: !!episodeId,
    staleTime: 30 * 1000, // 30 segundos
  });
}

export function useClearWatchHistory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await dramatstraAPI.watchHistory.list({ limit: 1 });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['watch-history'] });
      toast.success('Histórico limpo');
    },
    onError: () => {
      toast.error('Erro ao limpar histórico');
    },
  });
}
